/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep =
  {
    ThreeThousandSixHundred: "3600",
    EightySixThousandFourHundred: "86400",
  } as const;
export type GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep =
  ClosedEnum<
    typeof GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep
  >;

export type GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest =
  {
    ledgerCanisterId: string;
    start?: number | undefined;
    end?: number | undefined;
    step?:
      | GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep
      | undefined;
    index?: number | undefined;
  };

/** @internal */
export const GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$inboundSchema:
  z.ZodNativeEnum<
    typeof GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep
  > = z.nativeEnum(
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep,
  );

/** @internal */
export const GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$outboundSchema:
  z.ZodNativeEnum<
    typeof GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep
  > =
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$ {
  /** @deprecated use `GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$inboundSchema` instead. */
  export const inboundSchema =
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$inboundSchema;
  /** @deprecated use `GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$outboundSchema` instead. */
  export const outboundSchema =
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$outboundSchema;
}

/** @internal */
export const GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$inboundSchema:
  z.ZodType<
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step:
      GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$inboundSchema
        .default("86400"),
    index: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$Outbound =
  {
    ledger_canister_id: string;
    start?: number | undefined;
    end?: number | undefined;
    step: string;
    index?: number | undefined;
  };

/** @internal */
export const GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$outboundSchema:
  z.ZodType<
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$Outbound,
    z.ZodTypeDef,
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step:
      GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetStep$outboundSchema
        .default("86400"),
    index: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$ {
  /** @deprecated use `GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$inboundSchema;
  /** @deprecated use `GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$outboundSchema;
  /** @deprecated use `GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$Outbound` instead. */
  export type Outbound =
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$Outbound;
}

export function getCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequestToJSON(
  getCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest:
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest,
): string {
  return JSON.stringify(
    GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$outboundSchema
      .parse(
        getCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest,
      ),
  );
}

export function getCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest' from JSON`,
  );
}
